import { combineReducers } from 'redux';
import shared from './reducers/shared';
import { fetchUserRoles } from './reducers/user';
import excelUpload from './reducers/excelUpload';
import excelUploadedFiles from './reducers/excelUploadedFiles';
import agentDashboard from './reducers/agentDashboard';
import catalogIntentFilter from './reducers/catalogIntentFilter';
import queryNormalization from './reducers/queryNormalization';
import queryExpansion from './reducers/queryExpansion';
import queryTagging from './reducers/queryTagging';
import qclCorrection from './reducers/qclCorrection';
import searchRuleEngine from './reducers/searchRuleEngine';
import catalogIntentFilterV2 from './reducers/catalogIntentFilterV2';

export default combineReducers({
  shared,
  fetchUserRoles,
  excelUpload,
  excelUploadedFiles,
  agentDashboard,
  catalogIntentFilter,
  queryNormalization,
  queryExpansion,
  queryTagging,
  qclCorrection,
  searchRuleEngine,
  catalogIntentFilterV2,
});
